/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useContext, useEffect } from 'react';
import { connect, useSelector, useDispatch } from 'react-redux';
import {
    object, string, array, func, shape, bool, arrayOf, number,
} from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { compose } from 'recompose';
import { withRouter } from 'react-router';

import {
    getCaCampaign, getPassportBundleItemCurrentlyInCart, getSelectedInlineAddons, getSSRDeviceType,
} from '../../../../../../../state/ducks/App/App-Selectors';

import ConnectedGraphqlAddToCartContainerUI from '../../GraphqlAddToCartContainerUI';
import ConnectedGraphqlFoodAddToCart from '../../GraphqlFoodAddToCart/GraphqlFoodAddToCart';
import { getProductDemandType, getAttributeByName, getCartAttributeByNameAndReturnValue } from '../../../../../../helpers/page/pageHelpers';
import { getPmallSummaryInfo } from '../../../../../../../state/ducks/Common/Common-Selectors';
import { CrossMerch } from '../../../../CrossMerchContainer/CrossMerchContainer';
import useIsPlaPage from '../../../../../../helpers/hooks/useIsPlaPage';
import useSSRMediaQuery from '../../../../../../helpers/hooks/useSSRMediaQuery';
import useSalesforcePersonalizedContentQuery from '../../../../../../helpers/Personalization/useSalesforcePersonalizedContentQuery';
import useClickStreamCustomEventsTracking from '../../../../../../helpers/Personalization/useClickstreamCustomEventsTracking';
import { trackEvent } from '../../../../../../../state/ducks/TagManager/ducks/TagManager/TagManager-Actions';
import { getBrand } from '../../../../../../../state/ducks/App/ducks/Brand/Brand-Selectors';

const styles = (theme) => ({
    cartWrapper: {
        [theme.breakpoints.down('xs')]: {
            display: 'grid',
            width: '100%',
        },
    },
    passportBanner: {
        display: 'inline-block',
        width: '60%',
        float: 'left',
        // Mobile
        [theme.breakpoints.down('md')]: {
            width: '100%',
        },
        [theme.breakpoints.down('xs')]: {
            'grid-row': 2,
            marginTop: 20,
        },
    },
    addToCart: {
        marginBottom: theme.spacing(3),
    },
    addToCartFullWidth: {
        width: '100%!important',
    },
    productName: {
        fontWeight: 400,
        fontSize: 20,
        marginTop: 0,
        marginBottom: 20,
    },
    deliveryMessage: {
        backgroundColor: 'rgba(255, 255, 255, 0)',
        boxSizing: 'border-box',
        color: theme.palette.cms?.clubAvailablility || '#404040',
        textAlign: 'center',
        margin: 0,
        lineHeight: 'normal',
    },

    dateInvalid: {
        position: 'relative',
        '&::before': {
            position: 'absolute',
            zIndex: '999',
            color: theme.palette.cms?.errorZipVerifyPDP || '#79000f',
            lineHeight: '25px',
            fontSize: '12px',
            border: 'none',
            fontWeight: '400',
            margin: '0px 0px 0px 20px',
            content: '"Please enter a valid date of birth !"',
            height: '22px',
            transition: 'opacity 0.3s ease-in',
            opacity: 1,
        },
    },

    grid: {
        width: '250px',
        height: '64px',
    },

    goDeluxeContainer: {
        // Mobile
        [theme.breakpoints.up('sm')]: {
            display: 'none',
        },
    },
    yotpoContainer: {
        paddingBottom: '10px',
        [theme.breakpoints.down('sm')]: {
            justifyContent: 'center',
        },
    },
});

const PDPAddToCart = ({
    classes,
    product,
    product: {
        availability,
        productSkus,
        brandId,
        partNumber,
        name,
        displayDeliveryCalendar,
    },
    deliveryData,
    selectedSku,
    sortedData,
    presentation_family,
    subscriptionDetails,
    subscription,
    location,
    isPassportBundleItem,
    passportBundleItemInCart,
    disableAddToCart,
    personalizedData,
    isAddToCartEnabled,
    hasWine,
    selectedAddons,
    handleMiniCartModalClick,
    quantity,
    isPassportBundleProduct,
    handleMobileAgeVerification,
    deviceType,
    deliverySLA,
    isStandAloneMovieSku,
    deliveryIndicator,
    productNotAvailable,
    pmallSummaryInfo,
    movieSelected,
    validVaseConfiguratorSku,
    content,
    isPdpRedesignEnabled,
    showAddToCart,
    showDeliveryField,
    showProductTitleTop,
    isPdpRedesignShortEnabled,
    isPdpRedesignSkuEnabled,
    addToCartButtonRedesign,
    isPlaRedesignEnabled,
    isPersistAddressEnabled,
    isWrapUpEnabled,
    salesforceResponseWrapUpShowHide,
    addToCartPriceShow,
    isCaDelivery,
    isDeliverCharges,
    setProductQuantity,
    addToCartPrice,
    stickyAtcEnabled,
    isMobilePdp,
    stickySkuRetail,
    stickySkuSale,
}) => {
    if (!product) {
        return null;
    }
    const dispatch = useDispatch();
    const { featureFlags = {} } = useContext(CrossMerch);
    const caCampaign = useSelector(getCaCampaign);

    const productDemandType = getProductDemandType(location);
    const brand = useSelector(getBrand);
    const selectedSkuDynamicPrice = caCampaign?.newPrices?.find?.((p) => p.id === selectedSku.id)?.prices || [];

    const isPassportEligible = product.isPassportEligible;
    const isMobile = (deviceType === 'mobile');
    const isTryMeProduct = !!getAttributeByName(product.attributes, 'try_me').length > 0;
    const MINI_CART_ENABLED = featureFlags['is-mini-cart-enabled'];
    const MINI_CART_V2_ENABLED = featureFlags['is-mini-cart-v2-enabled'];
    const productDeliveryType = availability?.productDeliveryType;
    const device = useSSRMediaQuery();
    const enableMinicart = MINI_CART_V2_ENABLED || (MINI_CART_ENABLED && useSelector(getSSRDeviceType) !== 'mobile');
    const isFlowersTempV1SubscriptionFeatureEnabled = featureFlags['is-pdp-subscription-enabled'];
    // if flag is on get the product show_wrapup data (from PIM) else leave it true to default wrapups/addons with wrapups as they currently are
    const showWrapup = featureFlags['is-wrapup-display-controlled-by-product-level-flag'] ? getCartAttributeByNameAndReturnValue(product.attributes, 'show_wrapup') : 'true';
    const isPlaPage = useIsPlaPage();
    const selectAddons = useSelector(getSelectedInlineAddons);
    const isPdpAddonsSectionEnabled =  featureFlags['is-pdp-add-ons-section-ab-test-enabled'];
    const { loading: loadingMessaging, variables: variablesMessaging, data: deliveryDateOptions } = useSalesforcePersonalizedContentQuery({
        queryName: 'deliveryDateOptions',
        interactionName: `${brand.domain} - Get Campaign - Show delivery date options on PDP`,
        featureFlag: featureFlags['is-delivery-date-options-on-pdp-ab-test-enabled'],
        optInHoldoutParticipation: false,
        resolveIdentity: false,
    });

    const { loading: loadingAddon, variables: variablesAddon, data: dataAddon } = useSalesforcePersonalizedContentQuery({
        queryName: 'pdpAddonPage',
        interactionName: `${brand.domain} - Get Campaign - PDP Add-ons Section`,
        featureFlag: isPdpAddonsSectionEnabled && productDeliveryType?.toLowerCase?.() !== 'gpt',
        optInHoldoutParticipation: false,
        resolveIdentity: false,
    });

    // CONTROL OR VARIANT(TEST) VALUE for Calendar Messaging Sales Force Test
    const addonDataUserGroup = dataAddon?.contentSF?.campaign?.campaignResponses?.[0]?.payload?.userGroup;
    const variantAddon = addonDataUserGroup?.toLowerCase() === 'test';

    useEffect(() => {
        // GA tracking
        if (typeof addonDataUserGroup !== 'undefined' && !window.wuPDPAddonPageFired && addonDataUserGroup) {
            const eventParam = {
                eventCategory: 'Experiment',
                eventAction: 'Addons ơn Product Page',
                eventLabel: variantAddon ? 'Variant' : 'Control',
                feature_detail: variantAddon ? 'Variant' : 'Control',
                feature_element: 'Addons ơn Product Page',
                feature_category: 'Experiment',
            };
            dispatch(trackEvent(eventParam));
            window.wuPDPAddonPageFired = true;
        }
        return () => {
            window.wuPDPAddonPageFired = false;
        };
    }, [addonDataUserGroup]);

    useClickStreamCustomEventsTracking({
        salesforceResponse: dataAddon?.contentSF,
        isFireImpression: true,
        page: 'product',
    });

    useClickStreamCustomEventsTracking({
        salesforceResponse: deliveryDateOptions?.contentSF,
        isFireImpression: true,
        page: 'product',
    });

    // CONTROL OR VARIANT(TEST) VALUE for Calendar Messaging Sales Force Test
    const isDeliveryOptionsUserGroup = deliveryDateOptions?.contentSF?.campaign?.campaignResponses?.[0]?.payload?.userGroup;
    const variantDeliveryOptions = isDeliveryOptionsUserGroup?.toLowerCase() === 'test' || featureFlags['force-delivery-date-options-variant-on-pdp'];

    useEffect(() => {
        // GA tracking
        setTimeout(() => {
            if (typeof isDeliveryOptionsUserGroup !== 'undefined' && !window.wuDeliveryDateButtonsFired && isDeliveryOptionsUserGroup) {
                const eventParam = {
                    eventCategory: 'Experiment',
                    eventAction: 'Delivery Date Buttons',
                    eventLabel: variantDeliveryOptions ? 'Variant' : 'Control',
                    feature_detail: variantDeliveryOptions ? 'Variant' : 'Control',
                    feature_element: 'Delivery Date Buttons',
                    feature_category: 'Experiment',
                };
                dispatch(trackEvent(eventParam));
                window.wuDeliveryDateButtonsFired = true;
            }
            return () => {
                window.wuDeliveryDateButtonsFired = false;
            };
        }, 1000);
    }, [isDeliveryOptionsUserGroup]);

    if (loadingMessaging || variablesMessaging?.skip || loadingAddon || variablesAddon?.skip) {
        return <></>;
    }
    const getAddons = () => {
        const addonsComponents = [];
        selectAddons?.forEach((addon) => {
            const addonItem = {
                brandCode: addon?.brandId,
                productCode: addon.partNumber,
                componentType: 'ADDON',
                productId: addon.legacyId,
                quantity: addon?.quantity,
            };
            addonsComponents.push(addonItem);
        });
        return addonsComponents;
    };
    return (
        <div className={classes.cartWrapper}>
            <div className={`${presentation_family === 'food' ? classes.addToCart : null} ${(product?.productType?.toLowerCase() === 'club' && isPassportEligible && !(!isPassportBundleItem && !passportBundleItemInCart)) ? classes.addToCartFullWidth : ''} `}>
                {presentation_family === 'food'
                    && (
                        <ConnectedGraphqlFoodAddToCart
                            isAddToCartEnabled={isAddToCartEnabled}
                            selectedItemId={selectedSku.id}
                            brandId={brandId}
                            productSkus={productSkus}
                            partNumber={partNumber}
                            categoryId={location.state?.categoryId || ''}
                            categoryPath={location.state?.categoryPath || ''}
                            categoryName={location.state?.categoryName || ''}
                            subscription={subscription}
                            subscriptionDetails={subscriptionDetails}
                            disableAddToCart={disableAddToCart}
                            personalizedData={personalizedData}
                            isPersonalizable={product?.isPersonalizable}
                            product={product}
                            presentation_family={presentation_family}
                            handleMiniCartModalClick={handleMiniCartModalClick}
                            quantity={quantity}
                            handleMobileAgeVerification={handleMobileAgeVerification}
                            isMobile={isMobile}
                            hasWine={hasWine}
                            isPassportBundleProduct={isPassportBundleProduct || {}}
                            productType={selectedSku?.productType}
                            addons={selectedAddons}
                            movieSelected={movieSelected?.skuSelected ? movieSelected : null}
                            productDemandType={productDemandType}
                            deliveryMethod={deliverySLA}
                            isTryMeProduct={isTryMeProduct}
                            deliveryIndicator={deliveryIndicator}
                            selectedSku={selectedSku}
                            featureFlags={featureFlags}
                            selectAddons={selectAddons}
                            content={content}
                            showAddToCart={showAddToCart}
                            showDeliveryField={showDeliveryField}
                            isPdpRedesignEnabled={isPdpRedesignEnabled}
                            isPdpRedesignSkuEnabled={isPdpRedesignSkuEnabled}
                            isPlaRedesignEnabled={isPlaRedesignEnabled}
                            isWrapUpEnabled={isWrapUpEnabled}
                            addToCartPriceShow={addToCartPriceShow}
                            isCaDelivery={isCaDelivery}
                            isDeliverCharges={isDeliverCharges}
                            setProductQuantity={setProductQuantity}
                            addToCartPrice={addToCartPrice}
                        />
                    )}
                {presentation_family === 'flower'
                    && (
                        <ConnectedGraphqlAddToCartContainerUI
                            brandId={brandId}
                            categoryId={location.state?.categoryId || ''}
                            categoryName={location.state?.categoryName || ''}
                            categoryPath={location.state?.categoryPath || ''}
                            deliveryData={deliveryData}
                            displayDeliveryCalendar={displayDeliveryCalendar ?? true}
                            enableMinicart={enableMinicart}
                            handleMiniCartModalClick={handleMiniCartModalClick}
                            handleMobileAgeVerification={handleMobileAgeVerification}
                            hasWine={hasWine}
                            isFlowersSubscriptionFeatureEnabled={featureFlags['is-pdp-subscription-enabled']}
                            isFlowersTempV1SubscriptionFeatureEnabled={isFlowersTempV1SubscriptionFeatureEnabled}
                            isPassportBundleItem={isPassportBundleItem}
                            isPassportBundleProduct={isPassportBundleProduct || {}}
                            isStandAloneMovieSku={isStandAloneMovieSku}
                            movieSelected={movieSelected?.skuSelected ? movieSelected : null}
                            partNumber={partNumber}
                            pmallSummaryInfo={pmallSummaryInfo}
                            presentation_family={presentation_family}
                            productDeliveryType={availability?.productDeliveryType}
                            validVaseConfiguratorSku={validVaseConfiguratorSku}
                            productCategories={product?.categories}
                            productName={name}
                            productNotAvailable={productNotAvailable}
                            productSkus={productSkus}
                            selectedSku={selectedSku}
                            skuData={sortedData}
                            subscription={subscription}
                            subscriptionDetails={subscriptionDetails}
                            showWrapup={showWrapup}
                            featureFlags={featureFlags}
                            isPlaPage={isPlaPage}
                            device={device}
                            content={content}
                            isPdpRedesignEnabled={isPdpRedesignEnabled}
                            showAddToCart={showAddToCart}
                            showDeliveryField={showDeliveryField}
                            showProductTitleTop={showProductTitleTop}
                            isPdpRedesignShortEnabled={isPdpRedesignShortEnabled}
                            addToCartButtonRedesign={addToCartButtonRedesign}
                            isPlaRedesignEnabled={isPlaRedesignEnabled}
                            isPersistAddressEnabled={isPersistAddressEnabled}
                            variantAddon={variantAddon}
                            selectAddons={selectAddons?.length > 0 ? getAddons() : []}
                            isWrapUpEnabled={isWrapUpEnabled}
                            salesforceResponseWrapUpShowHide={salesforceResponseWrapUpShowHide}
                            variantDeliveryOptions={variantDeliveryOptions}
                            addToCartPriceShow={addToCartPriceShow}
                            isCaDelivery={isCaDelivery}
                            isDeliverCharges={isDeliverCharges}
                            addToCartPrice={addToCartPrice}
                            stickyAtcEnabled={stickyAtcEnabled}
                            isMobilePdp={isMobilePdp}
                            stickySkuRetail={stickySkuRetail}
                            stickySkuSale={stickySkuSale}
                        />
                    )}
            </div>
        </div>
    );
};

PDPAddToCart.propTypes = {
    movieSelected: object.isRequired,
    classes: object.isRequired,
    product: object.isRequired,
    deliveryData: object.isRequired,
    partNumber: string,
    hasWine: bool.isRequired,
    presentation_family: string.isRequired,
    selectedSku: object.isRequired,
    sortedData: array.isRequired,
    subscriptionDetails: shape({
        subscriptionType: string,
        subscriptionDuration: string,
        subscriptionFrequency: string,
    }),
    subscription: shape({
        subscriptionKey: array,
        subscriptionIndefinite: string,
        subscriptionType: array,
        implementProductSubscription: bool,
        viewSubscription: bool,
        isTypeDiscovery: bool,
    }),
    location: object.isRequired,
    isPassportBundleItem: bool,
    passportBundleItemInCart: bool.isRequired,
    displayDeliveryCalendar: bool,
    disableAddToCart: bool,
    personalizedData: shape({
        personalizationType: string,
        personalizationLines: arrayOf({
            perAttributeValue: string,
        }),
    }),

    isAddToCartEnabled: bool.isRequired,
    selectedAddons: arrayOf(string),
    handleMiniCartModalClick: func.isRequired,
    quantity: string,
    isPassportBundleProduct: shape({
        prices: {
            value: number,
        },
        enable: bool,
    }),
    handleMobileAgeVerification: func,
    deviceType: string,
    deliverySLA: string,
    isStandAloneMovieSku: bool,
    deliveryIndicator: string.isRequired,
    productNotAvailable: shape({
        product_not_available_text: string.isRequired,
        cta_text: string.isRequired,
    }),
    pmallSummaryInfo: shape({
        customizations: arrayOf(
            shape({
                refnum: string,
                description: string,
                'preview-url': string,
            }),
        ),
    }).isRequired,
    validVaseConfiguratorSku: bool.isRequired,
    content: object,
    isPdpRedesignEnabled: bool,
    showAddToCart: bool,
    showDeliveryField: bool,
    showProductTitleTop: bool,
    isPdpRedesignShortEnabled: bool,
    isPdpRedesignSkuEnabled: bool,
    addToCartButtonRedesign: bool,
    isPlaRedesignEnabled: bool,
    isPersistAddressEnabled: bool,
    isWrapUpEnabled: bool,
    salesforceResponseWrapUpShowHide: object,
    addToCartPriceShow: object,
    isCaDelivery: bool,
    isDeliverCharges: bool,
    setProductQuantity: func,
    addToCartPrice: number,
    stickyAtcEnabled: bool,
    isMobilePdp: bool,
    stickySkuRetail: number,
    stickySkuSale: number,
};

PDPAddToCart.defaultProps = {
    partNumber: null,
    isStandAloneMovieSku: false,
    subscriptionDetails: {},
    subscription: {},
    isPassportBundleItem: false,
    disableAddToCart: false,
    personalizedData: {},
    displayDeliveryCalendar: true,
    selectedAddons: [],
    quantity: '',
    isPassportBundleProduct: {},
    handleMobileAgeVerification: () => {},
    deviceType: '',
    deliverySLA: '',
    productNotAvailable: {},
    content: {},
    isPdpRedesignEnabled: false,
    showAddToCart: true,
    showDeliveryField: true,
    showProductTitleTop: false,
    isPdpRedesignShortEnabled: false,
    isPdpRedesignSkuEnabled: false,
    addToCartButtonRedesign: false,
    isPlaRedesignEnabled: false,
    isPersistAddressEnabled: false,
    isWrapUpEnabled: false,
    salesforceResponseWrapUpShowHide: {},
    addToCartPriceShow: null,
    isCaDelivery: false,
    isDeliverCharges: false,
    setProductQuantity: () => {},
    addToCartPrice: '',
    stickyAtcEnabled: false,
    isMobilePdp: false,
    stickySkuRetail: null,
    stickySkuSale: null,
};

const mapStateToProps = (state) => ({
    passportBundleItemInCart: getPassportBundleItemCurrentlyInCart(state),
    pmallSummaryInfo: getPmallSummaryInfo(state),
});
const enhance = compose(
    withRouter,
    connect(mapStateToProps),
    withStyles(styles),
);

export default enhance(PDPAddToCart);
